export const NAMESPACE = 'Start';
export const LOAD_START = 'Start/LOAD_START';
